import React from 'react';
import styled from 'styled-components';

import {VisualSizesEnum} from '../../styles/commonStyles';
import {StepHeader, StepHeaderProps} from './stepHeader';

/*
 * Props.
 */

type SingleStepProps<T> = Pick<StepHeaderProps, 'title' | 'description' | 'isDisabled' | 'isSelected'> & {
  id: T;
};

export type StepsListSteps<T extends string = string> = ReadonlyArray<SingleStepProps<T>>;

interface StepsListProps<T extends string = string> {
  size?: VisualSizesEnum;
  steps: StepsListSteps<T>;
  className?: string;
  onStepClick?: (stepId: T) => void;
}

/*
 * Style.
 */

const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 180px;
  flex-shrink: 0;
`;

/*
 * Component.
 */

export const StepsList = <T extends string = string>(props: StepsListProps<T>) => (
  <StyledDiv className={props.className}>
    {props.steps.map((step, index) => (
      <StepHeader
        key={step.id}
        stepNumber={index + 1}
        isDisabled={step.isDisabled}
        isSelected={step.isSelected}
        description={step.description}
        title={step.title}
        size={props.size}
        onClick={
          step.isDisabled
            ? undefined
            : () => {
                props.onStepClick?.(step.id);
              }
        }
      />
    ))}
  </StyledDiv>
);
